import { userpermissionActions } from "./userpermission-slice";
import { uiActions } from "../ui-slice";

export const GetUserpermission = (id, email, showNotification) => {
  return async (dispatch) => {
    if (showNotification !== undefined && showNotification === true) {
      dispatch(
        uiActions.showNotification({
          status: "pending",
          title: "Solicitando permiso",
          message: "Solicitando permiso al servidor.",
        })
      );
    }
    const getUserpermissionInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/UserPermission/getById`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            userId: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener el permiso");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getUserpermissionInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          userpermissionActions.setUserpermissions({
            userpermissions: response.data.roles,
          })
        );
        if (showNotification !== undefined && showNotification === true) {
          dispatch(
            uiActions.showNotification({
              status: "success",
              title: "Datos Cargados",
              message: response.result.message,
            })
          );
        }
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          userpermissionActions.setUserpermission({
            userpermission: {},
          })
        );
        if (showNotification !== undefined && showNotification === true) {
          dispatch(
            uiActions.showNotification({
              status: "warning",
              title: "Advertencia",
              message: response.result.message,
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener el permiso",
        })
      );
    }
  };
};

export const UpdateUserpermission = (userpermission, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Actualizando permiso",
        message: "Solicitando Actualización del permiso al servidor.",
      })
    );
    const updateUserpermissionInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/userpermission/update`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: userpermission.id,
            Name: userpermission.name,
            Description: userpermission.description,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo actualizar el permiso");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await updateUserpermissionInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          userpermissionActions.setUserpermission({
            userpermission: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Permiso Actualizado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          userpermissionActions.setUserpermission({
            userpermission: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar el permiso",
        })
      );
    }
  };
};

export const CreateUserpermission = (userpermission, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Creando permiso",
        message: "Solicitando Creación del permiso al servidor.",
      })
    );
    const createUserpermissionInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/UserPermission/add`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            userId: userpermission.userId,
            permissions: userpermission.permissions,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo agregar el permiso");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await createUserpermissionInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          userpermissionActions.setUserpermission({
            userpermission: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Permiso Creado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          userpermissionActions.setUserpermission({
            userpermission: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo agregar el permiso",
        })
      );
    }
  };
};

export const RemoveUserpermission = (userPermission, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Removiendo permiso",
        message: "Removiendo permiso en el servidor",
      })
    );
    const updateUserpermissionInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/UserPermission/delete`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            userId: userPermission.userId,
            permissions: userPermission.permissions,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo actualizar el permiso");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await updateUserpermissionInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          userpermissionActions.setUserpermission({
            userpermission: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Permiso Actualizado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          userpermissionActions.setUserpermission({
            userpermission: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar el permiso",
        })
      );
    }
  };
};
